export const tapRequestStatusesEnum = {
  Nuevo: 1,
  Sometido: 2,
  'Proceso de Consulta': 3,
  'Devuelto a la Escuela': 4,
  'Proceso de Análisis del CSEE': 5,
  'Devuelto al Facilitador Docente': 6,
  'Recomendado a Evaluación de CSEE': 7,
  'Recomendado a Evaluación de Nivel Central': 10,
  'Proceso de Análisis de Nivel Central': 11,
  'Devuelto al Director de CSEE': 12,
  'Devuelto a Nivel Central': 14,
  Aprobado: 15,
  'No Aprobado': 16, 
  'Pendiente Revision de Escuela': 17,
  'Sometido Revisado': 18,
  'Recomendado al(la) Secretario(a)': 19,
  'No Recomendado': 20,
  Notificado: 21,
  'Proceso de Análisis del(la) Secretario(a)': 22,
  Asignado: 23,
  Enmendado: 24,
  'Proceso de Enmienda': 25,
  NoVigenteBaja: 26,
  NoVigenteEgreso: 27,
  NoVigenteTraslado: 28,
  'Denegado': 29,
};

export const tapRequestQuestionnaireTypes = {
  SolicitudAsistenciaTecnicaUbicaciónEstudiante: 13,
};

export const tapRequestQuestionSectionsEnum = {
  EstudianteRezagosIdioma: 34,
  EstudianteProblemasConductuales: 35,
  PropositoConsultaFacilitador: 36,
  RecomendarCOMPUParaAnalisisFacilitador: 37,
  RecomendarCOMPUParaAnalisisCSEE: 38,
  OreRecomendacionNivelCentral: 39,
};

export const tapRequestTypesEnum = {
  FacilitatorAnalysis: 1,
  DirectorAnalysis: 2,
  CentralLevelAnalysis: 3,
  SAEEAnalysis: 4,
};

export const determinationTypeEnum = {
  CompraServicio: 1,
  Reembolso: 2,
  PagoDirecto: 3,
};

export const gradesEnum = {
  Prekindergarten: 1,
  Kindergarten: 2,
};

export const requesTypes={
  conversion:"Conversión",
  nuevo:"Nuevo",
  querella:"Querella",
  renovacion:"Renovación"
}
